const IMPORT = {
  title: 'Import de donnée',
  breadcrumb: {
    config: 'import de données',
  },
  info: {
    title: 'A lire avant action',
    message: 'Etape 1 : Prendre le template puis le remplir (ce qui n\'est pas dans les colonnes n\'est pas géré)<br>'
      + 'Etape 2 : Importer le fichier<br>'
      + 'Etape 3 : Tester l\'envoi de données et corriger les données en suivant les messages du fichier de retour<br>'
      + 'Etape 4 : Envoyer les données',
  },
  commande: {
    title: 'Importer des commandes',
    description: 'Le script n\'ajoute que les colonnes du fichier excel<br>'
      + 'Le script prend la société courante<br>'
      + 'Tester l\'envoie de données<br>'
      + 'Il faut que le code du client soit unique pour les lignes d\'une commande<br>'
      + 'Il faut que le code du client existe en base de données<br>'
      + 'Il faut que la référence du produit existe en base de données<br>'
      + 'Il faut que la date de la commande soit unique pour les lignes d\'une commande<br>'
      + 'Il faut que les colonnes de date soient au format texte<br>'
      + 'Regarder si tous les champs sont corrects<br>',
    errors: {
      dateCommandeWrongFormat: 'La date de commande doit être valide et au format DD/MM/YYYY',
      numCommandeRequired: 'Le numéro de commande est obligatoire',
      clientRequiered: 'Le client est obligatoire',
      produitRequiered: 'Le produit est obligatoire',
      quantiteIsInvalide: 'La quantité est invalide',
      prixUnitaireIsInvalide: 'Le prix unitaire est invalide',
      tauxRemiseIsInvalide: 'Le taux de remise est invalide',
      totalHtIsInvalide: 'Le total HT est invalide',
      tauxTvaIsInvalide: 'Le taux de TVA est invalide',
      dateCommandeNotSameAsFirstLine: 'La date de commande doit être la même pour toutes les lignes de la commande',
      clientNotSameAsFirstLine: 'Le client doit être le même pour toutes les lignes de la commande',
      produitReferenceNotExistInDb: 'La référence du produit n\'existe pas en base de données',
      clientCodeNotExistInDb: 'Le code client n\'existe pas en base de données',
      tauxTvaNotExistInDb: 'Le taux de tva n\'existe pas en base de données',
      productHasManyParent: 'Le produit est lié à plusieurs produits parents',
      productReferenceIsNotUnique: 'La référence du produit n\'est pas unique en base de données',
    },
  },
};

export default IMPORT;
